import { Parent } from './types/auth-response.model';

export const getRecentlyOpenedPayload = (item: Parent) => {
  return {
    identifier: 'Page',
    identifier_pk_id: item.name
  }
}

export const getFavoritePayload = (item: Parent, isFavorite) => {
  return {
    identifier: item.is_pb_page ? 'Page' : 'Scenario',
    identifier_pk_id: item.is_pb_page ? item.name : item.scenario_id.toString(),
    is_favourite: isFavorite
  };
};
